module.exports = __webpack_public_path__ + "img/QR.e1256cf2.jpg";